export const apiField = 's5_roof_panel';

const makeOptions = data => data.map(item => typeof item === 'object' ? item : ({ value: item, name: item }));


function makeConfig(data) {
  return{
    label: 's5RoofPanel',
    type: 'Select',
    apiField,
    missing: undefined,
    tooltip: undefined,
    data: makeOptions(data)
}};



export default function s5RoofPanel(filteredpanelTypeValues){
      return makeConfig(filteredpanelTypeValues);
    }
